import React from 'react'
import className from 'classnames'

const Spinner = (props) => {
  const size = props.size || 2
  const inlineClass = props.viewType === 'inline' ? 'inline' : ''
  return (
    <div className={className([props.className, inlineClass])}>
      <i className={`fas fa-spinner fa-spin fa-${size}x`} />
    </div>
  )
}

Spinner.defaultProps = {
  className: null
}

export const VCSpinner = (props) => {
  if (!props.visible) { return null }

  return (<Spinner {...props} />)
}

export default Spinner
